import { render, staticRenderFns } from "./DocumentListContainer.vue?vue&type=template&id=525a3b16&scoped=true"
import script from "./DocumentListContainer.vue?vue&type=script&lang=js"
export * from "./DocumentListContainer.vue?vue&type=script&lang=js"
import style0 from "./DocumentListContainer.vue?vue&type=style&index=0&id=525a3b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525a3b16",
  null
  
)

export default component.exports